import classes from './SectionOptions.module.scss';

const SectionOptions = ({ className, sectionOptions, onChange, currentOption }) => {
  const containerClasses = [classes['div-section-options']];
  if (className) {
    containerClasses.push(className);
  }

  const changeHandler = key => {
    onChange(key);
  };

  return (
    <div className={containerClasses.join(' ')}>
      {sectionOptions.map(({ key, label, labelMobile }) => {
        const currentSelected = currentOption === key;
        const classColor = currentSelected ? `${classes.active} bold-16` : `${classes.inactive} semibold-16 `;
        const boxStyle = [classes.standar, 'pointer'];
        if (currentSelected) {
          boxStyle.push(classes.selected);
        }
        return (
          <div
            key={key}
            name={key}
            id={currentSelected ? 'checked' : 'not-checked'}
            onClick={!currentSelected ? () => changeHandler(key) : () => {}}
            className={boxStyle.join(' ')}>
            <span className={`${classes.desktop} ${classColor}`}>{label}</span>
            <span className={`${classes.mobile} ${classColor}`}>{labelMobile}</span>
          </div>
        );
      })}
    </div>
  );
};

export default SectionOptions;
